/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InitiatePaymentResponse } from '../models/InitiatePaymentResponse';
import type { MakeSubscriptionPaymentRequest } from '../models/MakeSubscriptionPaymentRequest';
import type { SubscriptionCheckoutResponse } from '../models/SubscriptionCheckoutResponse';
import type { SubscriptionInvoiceItemResponse } from '../models/SubscriptionInvoiceItemResponse';
import type { SubscriptionInvoiceResponse } from '../models/SubscriptionInvoiceResponse';
import type { VerifySubscriptionPaymentResponse } from '../models/VerifySubscriptionPaymentResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubscriptionPaymentRestControllerService {
  /**
   * makePayment
   * @returns InitiatePaymentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static makePaymentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: MakeSubscriptionPaymentRequest;
  }): CancelablePromise<InitiatePaymentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/subscription-payments',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getCheckoutResponse
   * @returns SubscriptionCheckoutResponse OK
   * @throws ApiError
   */
  public static getCheckoutResponseUsingGet({
    termId,
    option,
  }: {
    /**
     * termId
     */
    termId: string;
    /**
     * option
     */
    option?: 'PREMIUM' | 'STANDARD' | 'STARTER';
  }): CancelablePromise<SubscriptionCheckoutResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-payments/checkout/{termId}',
      path: {
        termId: termId,
      },
      query: {
        option: option,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getPaymentHistory
   * @returns SubscriptionInvoiceItemResponse OK
   * @throws ApiError
   */
  public static getPaymentHistoryUsingGet({
    sessionId,
  }: {
    /**
     * sessionId
     */
    sessionId: string;
  }): CancelablePromise<Array<SubscriptionInvoiceItemResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-payments/history/{sessionId}',
      path: {
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getInvoiceData
   * @returns SubscriptionInvoiceResponse OK
   * @throws ApiError
   */
  public static getInvoiceDataUsingGet({
    sessionId,
  }: {
    /**
     * sessionId
     */
    sessionId: string;
  }): CancelablePromise<SubscriptionInvoiceResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-payments/invoice-data',
      query: {
        sessionId: sessionId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * verifyPayment
   * @returns VerifySubscriptionPaymentResponse OK
   * @throws ApiError
   */
  public static verifyPaymentUsingGet2({
    safsimsTransactionRef,
  }: {
    /**
     * safsims_transaction_ref
     */
    safsimsTransactionRef: string;
  }): CancelablePromise<VerifySubscriptionPaymentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription-payments/verify/{safsims_transaction_ref}',
      path: {
        safsims_transaction_ref: safsimsTransactionRef,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
